import React from "react";

const NavButton = ({ title, icon, active, onClick }) => {
    return (
        <li className="nav-item mx-1 my-1">
            <button type="submit" onClick={onClick} className={`mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle ${active ? "btn-primary" : ""}`}>
                <i className="material-icons mx-1">{icon}</i>
                {title}
            </button>
        </li>
    );
};
export default NavButton;
